var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "privacy-layout" } }, [
    _c("div", { staticClass: "container" }, [
      _c("h1", { staticClass: "privacy-title" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.title"))),
      ]),
      _c("h2", { staticClass: "privacy-subtitle" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.subtitle1"))),
      ]),
      _c("p", { staticClass: "main-paragraph" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.paragraph1"))),
      ]),
      _c("h2", { staticClass: "privacy-subtitle" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.subtitle2"))),
      ]),
      _c("p", { staticClass: "main-paragraph" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.paragraph2"))),
      ]),
      _c("h2", { staticClass: "privacy-subtitle" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.subtitle3"))),
      ]),
      _c("p", { staticClass: "main-paragraph last-paragraph" }, [
        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.bpce.legal.paragraph3"))),
      ]),
      _c(
        "a",
        {
          staticClass: "text-link",
          attrs: { href: "mailto:info@multiasistencia.com" },
        },
        [_vm._v("info@multiasistencia.com")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }